import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { MUTUAL_FUNDS_JOB_BASE_PATH } from '../../../../../../../../../features/mutual-funds/job/mutual-funds-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'mutual-funds-job-list',
        label: 'Mutual Funds',
        to: MUTUAL_FUNDS_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
